// The small gradient "beta" pill shown next to a tab title.
export const BetaBadge = () => (
  <span className="rounded-full bg-gradient-to-r from-fuchsia-500 to-amber-400 px-1.5 py-[1px] text-[9px] font-bold uppercase leading-none tracking-wide text-white shadow-sm">
    beta
  </span>
);
